// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { secondaryNavigationStyles } from "@eisinc/Overrides/Widgets/Header/SecondaryNavigation";
import { layoutContainer } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

secondaryNavigationStyles.languageLink = {
    css: css`
        flex: 0 0 auto;
        margin-left: 30px;
    `,
};
secondaryNavigationStyles.warehousePickupLink = {
    css: css`
        flex: 0 1 auto;
        margin-left: 30px;
        min-width: 0;
    `,
};
secondaryNavigationStyles.signInLink = {
    css: css`
        flex: 0 0 auto;
        margin-left: 30px;
    `,
};
secondaryNavigationStyles.container = {
    css: css`
        width: 100%;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        height: 34px;
        ${layoutContainer}
    `,
};